import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "survey-main" }
const _hoisted_2 = { class: "survey-main__header" }
const _hoisted_3 = { class: "survey-main__info-sections" }
const _hoisted_4 = {
  key: 0,
  class: "survey-main__participation survey-main__info-section"
}
const _hoisted_5 = { class: "survey-main__info-section-header" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_7 = { class: "survey-main__info-body" }
const _hoisted_8 = {
  key: 1,
  class: "survey-main__benefits survey-main__info-section"
}
const _hoisted_9 = { class: "survey-main__info-section-header" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_11 = { class: "survey-main__info-body" }
const _hoisted_12 = {
  key: 2,
  class: "survey-main__confidentiality survey-main__info-section"
}
const _hoisted_13 = { class: "survey-main__info-section-header" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_15 = { class: "survey-main__info-body" }
const _hoisted_16 = {
  key: 3,
  class: "survey-main__questions survey-main__info-section"
}
const _hoisted_17 = { class: "survey-main__info-section-header" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_19 = { class: "survey-main__info-body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_h1 = _resolveComponent("n-h1")!
  const _component_n_h2 = _resolveComponent("n-h2")!
  const _component_n_h3 = _resolveComponent("n-h3")!
  const _component_n_radio = _resolveComponent("n-radio")!
  const _component_n_radio_group = _resolveComponent("n-radio-group")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_n_h1, { class: "survey-main__header-title" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.name), 1)
        ]),
        _: 1
      }),
      _createElementVNode("p", null, _toDisplayString(_ctx.introduction), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_ctx.participation)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_n_h2, { class: "survey-main__info-title" }, {
                default: _withCtx(() => [
                  _createTextVNode("Participation")
                ]),
                _: 1
              }),
              _hoisted_6
            ]),
            _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.participation), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.benefits)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_n_h2, { class: "survey-main__info-title" }, {
                default: _withCtx(() => [
                  _createTextVNode("Benefits")
                ]),
                _: 1
              }),
              _hoisted_10
            ]),
            _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.benefits), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.confidentiality)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_n_h2, { class: "survey-main__info-title" }, {
                default: _withCtx(() => [
                  _createTextVNode("Confidentiality/Risks")
                ]),
                _: 1
              }),
              _hoisted_14
            ]),
            _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.confidentiality), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.questions)
        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createVNode(_component_n_h3, { class: "survey-main__info-title" }, {
                default: _withCtx(() => [
                  _createTextVNode("Questions")
                ]),
                _: 1
              }),
              _hoisted_18
            ]),
            _createElementVNode("p", _hoisted_19, _toDisplayString(_ctx.questions), 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_n_radio_group, {
      value: _ctx.hasAgreedRef,
      "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.hasAgreedRef) = $event)),
      class: "survey-main__consent-agreement"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: _normalizeClass({ 'survey-main__consent-button': true, 'active-consent-button': _ctx.hasAgreedRef }),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setAgreed(true)))
        }, [
          _createVNode(_component_n_radio, {
            value: true,
            label: "I agree to participate"
          })
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass({ 'survey-main__consent-button': true, 'active-consent-button': !_ctx.hasAgreedRef }),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setAgreed(false)))
        }, [
          _createVNode(_component_n_radio, {
            value: false,
            label: "No, I do not agree to participate"
          })
        ], 2)
      ]),
      _: 1
    }, 8, ["value"])
  ]))
}